const usedAppointmentAction = {
  appointmentAction: {
    label: "Action",
    invalid: {
      assertEmpty: "L'action ne peut pas être vide."
    }
  },
  quantity: {
    label: "Quantité",
    invalid: {
      assertEmpty: "La quantité ne peut pas être vide."
    }
  },
};

export default usedAppointmentAction;
